<template>
    <DefaultTemplate>
        <div class="column" :class="maxWidth > 768 ? '':'pd-3'">
            <b-loading :active.sync="isLoadingPage"></b-loading>
            <ValidationObserver ref="observer" v-slot="{ passes }">
                <div class="card rounded signup text-center">
                    <h2>สมัครสมาชิก</h2>
                    <div class="columns has-text-left flex-warp mg-t-4">
                        <div class="column is-6 ">
                            <BInputWithValidation
                                rules="required"
                                label="ชื่อ"
                                v-model="form.name"
                            />
                        </div>
                        <div class="column is-6">
                            <BInputWithValidation
                                rules="required"
                                label="นามสกุล"
                                v-model="form.surname"
                            />
                        </div>
                        <div class="column is-6 ">
                            <BInputWithValidation rules="required|email" type="email" label="อีเมล" v-model="form.email"/>
                        </div>
                        <div class="column is-6 " />
                        <div class="column is-6 ">
                            <BInputWithValidation
                                rules="required|min:8"
                                type="password"
                                label="รหัสผ่าน"
                                vid="password"
                                v-model="form.password"
                            />
                        </div>
                        <div class="column is-6">
                            <BInputWithValidation
                                rules="required|confirmed:password"
                                name="Password"
                                type="password"
                                label="ยืนยันรหัสผ่าน"
                                v-model="form.confirmPassword"
                            />
                        </div>
                    </div>
                    <b-button @click="passes(signup)" :style="styleObject" class="mg-t-4 button-secondary">สมัครสมาชิก</b-button>
                    <p class="pd-t-2">หากคุณมีบัญชีเพื่อเข้าใช้งานระบบแล้ว? <a :href="`/join-form/${$route.params.formId}/${$route.params.adminId}`">เข้าสู่ระบบ</a></p>
                </div>
            </ValidationObserver>
        </div>
    </DefaultTemplate>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import BInputWithValidation from "@/components/inputs/BInputWithValidation";
import DefaultTemplate from '@/template/DefaultTemplate'
import { HTTP } from "@/service/axios.js";
import {
    alertSignupSuccess,
    alertSignupFail,
    alertSignupEmailFail,
    alertCatchError
} from "@/service/alert";

export default {
    components:{
        DefaultTemplate,
        ValidationObserver,
        BInputWithValidation
    },
    computed:{
        user(){
            return this.$store.state.user
        }
    },
    data() {
        return {
            form:{
                name:'',
                surname:'',
                email:'',
                password:'',
                confirmPassword:''
            },
            isLoadingPage:false
        }
    },
    mounted(){
        if(this.user != null){
            this.joinForm(this.user)
        }
    },
    methods: {
        signup(){
            this.isLoadingPage = true
            let obj = {
                email:this.form.email,
                name: this.form.name,
                surname:this.form.surname,
                password:this.form.password,
                department:'',
                position:'',
                userLevel:50
            }

            HTTP.post(`sign/up`, obj)
            .then((res) => {
                console.log('signup',res)
                if (res.data.success) {
                    if(typeof this.$route.params.formId != 'undefined' && typeof this.$route.params.adminId != 'undefined'){
                        this.signin()
                    }
                     this.alertSignupSuccess()
                }else if(res.data.data == 'email is not work.'){
                    this.alertSignupEmailFail()
                }else{
                    this.alertSignupFail()
                }
            })
            .catch((e) => {
                this.alertCatchError()
            })
            .finally(() => {
                this.isLoadingPage = false
            })
        },
        signin(){
            let obj = {
                email:this.form.email,
                password:this.form.password
            }
            HTTP.post('sign/in',obj).then(res=>{
                console.log('sign/in',res)
                if(res.data.success){
                    this.$store.commit('SET_USER',res.data.obj)
                    if(typeof this.$route.params.formId != 'undefined' && typeof this.$route.params.adminId != 'undefined'){
                        this.joinForm(res.data.obj)
                    }
                }else{
                    this.animated = true;
                    this.textError =
                      "อีเมลหรือรหัสผ่านไม่ถูกต้อง กรุณากรอกใหม่อีกครั้ง";
                }
            }).finally(()=>{
                setTimeout(()=>{
                    this.textError = null;
                    this.animated = false;
                },5000)
            }).catch(e => {
              console.log("/api/user/signin/error", e);
              if (!e.response || typeof e.response != 'undefined') {
                this.textError =
                  "Cannot connect to server. Please contact the system administrator.";
                if (e.response.status === 404) {
                  this.textError = "Server in maintenance";
                } else if (e.response.status === 405) {
                  this.textError =
                    "อีเมลหรือรหัสผ่านไม่ถูกต้อง กรุณากรอกใหม่อีกครั้ง";
                } else {
                  this.textError = e.response.data.message;
                }
              } else {
                this.textError = e.response.data.message;
              }
            });
        },
        joinForm(user){
            let obj = {
                userId:user._id,
                formId:this.$route.params.formId,
                templateId:this.$route.params.adminId,
            }
            HTTP.post('/join/form',obj).then(res=>{
                console.log('/join/form',res)
                if (res.data.success) {
                    let userData = this.user
                    let form = this.formData
                    if(res.data.obj != null){
                        form.push(res.data.obj)
                        this.$store.commit('SET_FORM',form)
                    }
                    this.setTheme(user)
                    if (user.userLevel == 80) {
                        this.$router.push('/assign-form')
                    }else {
                        if(form.length == 0){
                            this.$router.push('/wait-form')
                        }else{
                            this.$router.push('/form-list')
                        }
                    }
                }
            })
        },
        setTheme(user){
            HTTP.defaults.headers.common.Authorization = `Bearer ${user.token}`;
            HTTP.get(`/template/${user._id}`).then(res=>{
                console.log(`/template/${user._id}`,res)
                if(res.data.success){
                    if(typeof res.data.obj.template != 'undefined'){
                        let setBg = {
                            label:'backGround',
                            child:'color',
                            value: user.userLevel == 60 ? res.data.obj.template.themeAdmin : res.data.obj.template.themeStaff 
                        }
                        this.$store.commit('SET_THEME',setBg)
                        let setBt = {
                            label:'button',
                            child:'backGroundColor',
                            value: user.userLevel == 60 ? res.data.obj.template.buttonAdmin : res.data.obj.template.buttonStaff
                        }
                        this.$store.commit('SET_THEME',setBt)
                        let setBtHover = {
                            label:'button',
                            child:'backGroundColorHover',
                            value:user.userLevel == 60 ? res.data.obj.template.buttonAdmin : res.data.obj.template.buttonStaff
                        }
                        this.$store.commit('SET_THEME',setBtHover)
                        let setTitle = {
                            label:'text',
                            child:'title',
                            value:res.data.obj.template.departmentName
                        }
                        this.$store.commit('SET_THEME',setTitle)
                        let setSubtitle = {
                            label:'text',
                            child:'subTitle',
                            value:res.data.obj.template.description
                        }
                        let setLogo = {
                            label:'text',
                            child:'logo',
                            value:res.data.obj.template.logo
                        }
                        this.$store.commit('SET_THEME',setLogo)
                    }
                }
            })
        }
    },
}
</script>